import { FormControl, InputLabel, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import React, { useEffect, useState } from "react";
import { EmailTemplateDD, TemplateMapper, Templates } from "../../../globalConstants";
import translate from "../../../i18n/translate";
import "./EmailTemplates.scss";

const EmailTemplates = () => {
    const distinctKeys = EmailTemplateDD.filter(
        (thing, i, arr) => arr.findIndex(t => t.name.toString() === thing.name.toString()) === i
    );
    useEffect(() => {
        const secondDropDown: string[] = [];
        const uuId: string[] = [];
        setddKey(0);
        setddKey2(0);
        EmailTemplateDD.forEach(data => {
            if (data !== null && typeof (data) !== 'undefined' && typeof (distinctKeys[0]) !== 'undefined' && distinctKeys.length > 0 && data.name === distinctKeys[0].name) {
                secondDropDown.push(data.topics[0].translation);
                uuId.push(data.topics[0].id);
            }
        });
        setddValue(secondDropDown);
        setCatSelection(true);
        setuuId(uuId);
        //handle event 2
        setddKey2(0);
        const selectedId: string = TemplateMapper.filter(mapper => mapper.uuId === uuId[0])[0].Id;
        const subjectTemp: string = Templates.filter(template => template.Id === selectedId)[0].subject;
        let messageTemp: string = Templates.filter(template => template.Id === selectedId)[0].message;
        let htmlMessage = refineText(messageTemp, '\r\n', '<br />');
        htmlMessage = refineText(htmlMessage, '\\\\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
        setSubject(subjectTemp);
        setMessage(htmlMessage);
        messageTemp = refineText(messageTemp, "<br>", "");
        messageTemp = refineText(messageTemp, "<br/>", "");
        messageTemp = refineText(messageTemp, "<p>", "");
        messageTemp = refineText(messageTemp, "</p>", "");
        const parsedSub = encodeURI(subjectTemp);
        const parsedMsg = encodeURI(messageTemp);
        setMailTo("mailto:?to=[EmailID]&subject=" + parsedSub
            + "&body=" + parsedMsg);
    }, []);
    const [dropdownKey] = useState(distinctKeys);
    const [ddKey, setddKey] = useState(0);
    const [ddKey2, setddKey2] = useState(0);
    const topic: string = "Select a topic";
    const [ddvalue, setddValue] = useState([topic]);
    const [isCatSelected, setCatSelection] = useState(false);
    const [uuid, setuuId] = useState({} as string[]);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [mailTo, setMailTo] = useState("");

    const refineText = (originalStr: string, findStr: string, replaceWithStr: string) => {
        const find = findStr;
        const re = new RegExp(find, 'g');
        return originalStr.replace(re, replaceWithStr);
    }

    const handleChange = (event: any) => {
        const secondDropDown: string[] = [];
        const uuId: string[] = [];
        setddKey(event.target.value);
        setddKey2(0);
        EmailTemplateDD.forEach(data => {
            if (data !== null && typeof (data) !== 'undefined' && typeof (distinctKeys[event.target.value]) !== 'undefined' && distinctKeys.length > 0 && data.name === distinctKeys[event.target.value].name) {
                secondDropDown.push(data.topics[0].translation);
                uuId.push(data.topics[0].id);
            }
        });
        setddValue(secondDropDown);
        setCatSelection(true);
        setuuId(uuId);
        setddKey2(0);
        const selectedId: string = TemplateMapper.filter(mapper => mapper.uuId === uuId[0])[0].Id;
        let subjectTemp: string = Templates.filter(temp => temp.Id === selectedId)[0].subject;
        let messageTemp: string = Templates.filter(temp => temp.Id === selectedId)[0].message;
        let htmlMessage = refineText(messageTemp, '\r\n', '<br />');
        htmlMessage = refineText(htmlMessage, '\\\\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
        setSubject(subjectTemp);
        setMessage(htmlMessage);
        messageTemp = refineText(messageTemp, '<p>', '');
        messageTemp = refineText(messageTemp, '</p>', '');
        messageTemp = refineText(messageTemp, '<b>', '');
        messageTemp = refineText(messageTemp, '</b>', '');
        messageTemp = refineText(messageTemp, '\\\\t', '    ');
        let parsedSub = encodeURI(subjectTemp);
        let parsedMsg = encodeURI(messageTemp);
        setMailTo("mailto:?to=[EmailID]&subject=" + parsedSub
            + "&body=" + parsedMsg);
    };

    const handleChangeValue = (event: any) => {
        setddKey2(event.target.value);
        const selectedId: string = TemplateMapper.filter(mapper => mapper.uuId === uuid[event.target.value])[0].Id;
        let subjectTemp: string = Templates.filter(temp => temp.Id === selectedId)[0].subject;
        let messageTemp: string = Templates.filter(temp => temp.Id === selectedId)[0].message;
        let htmlMessage = refineText(messageTemp, '\r\n', '<br />');
        htmlMessage = refineText(htmlMessage, '\\\\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
        setSubject(subjectTemp);
        setMessage(htmlMessage);
        messageTemp = refineText(messageTemp, "<br>", "");
        messageTemp = refineText(messageTemp, "<br/>", "");
        messageTemp = refineText(messageTemp, "<p>", "");
        messageTemp = refineText(messageTemp, "</p>", "");
        let parsedSub = encodeURI(subjectTemp);
        let parsedMsg = encodeURI(messageTemp);
        setMailTo("mailto:?to=[EmailID]&subject=" + parsedSub
            + "&body=" + parsedMsg);
    };

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            width: 402,
            height: 50,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }));
    const classes = useStyles();

    return (
        <div className="emailWrapper">            
            <div className="EmailTitle">
                <div>
                    <h3>{translate("feature_emailTemplates_title")}</h3>
                    <Typography >{translate("Blob")}</Typography>
                </div>
            </div>
            <div className="ddSection_wrapper" >
            <div className="ddSection">
                <div className="dropdownDiv">
                <div className="dropdownDiv_section">
                    <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="CategoryLabel">{translate("SelectACategory")}</InputLabel>
                            <Select
                                labelId="CategoryLabel"
                                id="category"
                                value={ddKey}
                                onChange={handleChange}
                                label={translate("SelectACategory")}
                            >
                                {
                                    dropdownKey && dropdownKey !== null && dropdownKey !== undefined && typeof (dropdownKey) !== undefined &&
                                    dropdownKey.map((value: any, index: number) => (
                                        <MenuItem value={index}>{translate(value.translation)}</MenuItem>
                                    )
                                    )
                                };
                                            </Select>
                        </FormControl>
                    
                    {/* <div className="selectClass"> */}
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="topic">{translate("SAT")}</InputLabel>
                            <Select
                                labelId="topic"
                                readOnly={!isCatSelected}
                                label={translate("SAT")}
                                id="topicLabel"
                                onChange={handleChangeValue}
                                value={ddKey2}
                            >
                                {
                                    (typeof (ddvalue) !== 'undefined' && ddvalue !== null) &&
                                    ddvalue.map((value: any, index: number) => (
                                        <MenuItem value={index}>{translate(value)}</MenuItem>
                                    )
                                    )
                                };

                            </Select>
                        </FormControl>
                        {/* </div> */}
                    </div>
                    < Typography className="quoteContent">
                        <p className="margin30"><i>"{translate("Quote1")}"</i> {translate("Quote1By")}</p>
                        <p><i>"{translate("Quote2")}" </i>{" "}{translate("Quote2By")}</p>
                        <p><i>"{translate("Quote3")}" </i>{" "}{translate("Quote3By")} </p>
                    </Typography>                    
                </div>

                <div className="contentSection">
                    <span className="templateButton"> {<Button href={mailTo} className="mailTo">{translate("OpenInEmail")}</Button>}</span>
                    {
                        <div className="subjectSection">

                            <span dangerouslySetInnerHTML={{ __html: subject }} />

                        </div>
                    }

                    {
                        <Typography>
                            <div className="messageSection">    <span dangerouslySetInnerHTML={{ __html: message }} /> </div>
                        </Typography>
                    }
                </div>


            </div>
            </div>
        </div >
    );
};

export default EmailTemplates;
